import { RootState } from 'data/root.reducers';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { showError, showSuccessMessage } from 'shared/toaster';
import { extractErrorMessage } from 'utils';
import i18n from 'i18n';
import * as certStatusApi from 'data/certStatus/certStatus.api';
import { CertStatus, CREATE_CERT_STATUS } from 'data/certStatus/certStatus.types';
import { AxiosError } from 'axios';
import * as api from './securityInfo.api';
import {
  GET_SECURITY_INFOS,
  GetSecurityInfoAction,
  CreateSecurityInfoThunkAction,
  SecurityInfo,
  OPEN_SECURITY_INFO_CREATE_POPUP,
  CLOSE_SECURITY_INFO_CREATE_POPUP,
  CREATE_SECURITY_INFO,
  SET_SECURITY_INFO_LOADING,
  SetSecurityInfoLoadingAction,
  OpenSecurityInfoCreatePopupAction,
  CloseSecurityInfoCreatePopupAction,
} from './securityInfo.types';

export function setSecurityInfoLoadingAction(isLoading: boolean): SetSecurityInfoLoadingAction {
  return {
    type: SET_SECURITY_INFO_LOADING,
    payload: { isLoading },
  };
}

export function openSecurityInfoCreatePopup(securityInfo?: SecurityInfo): OpenSecurityInfoCreatePopupAction {
  return {
    type: OPEN_SECURITY_INFO_CREATE_POPUP,
    payload: { securityInfo },
  };
}

export function closeSecurityInfoCreatePopup(): CloseSecurityInfoCreatePopupAction {
  return {
    type: CLOSE_SECURITY_INFO_CREATE_POPUP,
  };
}

export function getSecurityInfos(deliveryFunctionId: string): GetSecurityInfoAction {
  return {
    type: GET_SECURITY_INFOS,
    payload: api.getSecurityInfos(deliveryFunctionId),
  };
}

export function createSecurityInfoFromForm(
  deliveryFunctionId: string,
  body: WithAuditDetails<SecurityInfo>,
  certStatusBody?: WithAuditDetails<CertStatus>,
): CreateSecurityInfoThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    dispatch(setSecurityInfoLoadingAction(true));

    try {
      await dispatch({
        type: CREATE_SECURITY_INFO,
        payload: api.createSecurityInfo(deliveryFunctionId, body),
      });

      if (certStatusBody) {
        await dispatch({
          type: CREATE_CERT_STATUS,
          payload: certStatusApi.createCertStatus(
            deliveryFunctionId,
            certStatusBody
          )
        });
      }

      dispatch(closeSecurityInfoCreatePopup());
      showSuccessMessage(i18n.t('securityInfo.create.success', { name: body.data?.name }), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('securityInfo.create.failed', { name: body.data?.name, error: errorMessage }));

    } finally {
      dispatch(setSecurityInfoLoadingAction(false));
      dispatch(getSecurityInfos(deliveryFunctionId));
    }
  };
}
